import type { Ref } from 'react';
import React from 'react';
import type { IconButtonProps as MuiButtonProps } from '@mui/material';
import { IconButton } from '@mui/material';
import MuiRouterLink from 'c-components/MuiRouterLink';
import type { LinkProps } from 'react-router-dom';

const IconLinkButton = ({ to, children, ...props }: MuiButtonProps & LinkProps, ref: Ref<any>) => (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <IconButton component={MuiRouterLink} to={to} {...props} ref={ref}>
        {children}
    </IconButton>
);

export default React.forwardRef(IconLinkButton);
